export const chartBarDeliverability = {
  series: [
    {
      name: "Taux de réponse",
      data: [0]
    }, {
      name: "Déliverabilité (sans réponse)",
      data: [0]
    }, {
      name: "Non délivré(s)",
      data: [0]
    }
  ],
  options: {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    labels: {
      style: {
        fontSize: "14px",
      },
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: undefined,
      formatter: function (val: number) {
        return val + "%"
      },
      textAnchor: 'middle',
      offsetX: 0,
      offsetY: 0,
      style: {
        fontSize: '16px',
        colors: ["#fff"]
      },
    },
    grid: {
      borderColor: "#B2BEC3",
      opacity: 1,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 10,
        borderRadiusApplication: 'end', // 'around', 'end'
        borderRadiusWhenStacked: 'last', // 'all', 'last'
      },
    },
    fill: {
      opacity: 1,
      colors: [
        "#3EBEA8",  // Green
        "#6737FF",  // Purple
        "#EFEBFF",  // Light purple
      ]
    },
    stroke: {
      show: true,
      width: 4,
      colors: ["transparent"],
    },
    xaxis: {
      axisTicks: {
        show: false,
        borderType: "solid",
        height: 6,
        offsetX: 0,
        offsetY: 0,
      },
      tickPlacement: "between",
      labels: {
        style: {
          fontSize: "12px",
        },
      },
      categories: [""],
    },
    legend: {
      show: false,
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "12px",
        },
        formatter: (value: number) => {
          return Math.round(value) + "%";
        },
      },
      min: 0,
      max: 100,
      tickAmount: 2,
    },
  },
}